/**
 * Split out of api.ts so the preview transport can throw the same error type
 * without importing api.ts and creating a cycle.
 */
export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly detail?: unknown,
  ) {
    super(message);
  }
}
